import UsersList from "../../main/modules/Users/pages/UsersList";

const userLayoutRoutes = [
    {
        path: "",
        name: "UsersList",
        component: UsersList,
        meta: {
            isAuth: true,
            module: "users",
            subModule: ""
        }
    },

]

export default userLayoutRoutes;